<template>
  <div>
    <v-layout column class="mt-0 ml-4">
      <header-elements icon='mdi-volume-high' @showUpload="showUpload=!showUpload" title='Audio'></header-elements>
      <elements-table :items="audios" :showUpload="showUpload" @showUpload="showUpload=!showUpload" title="Audio"></elements-table>

        <!-- <div class="mt-1 mb-0">
          <v-flex style="background-color:#f2f2f2;" class="px-3 pt-1 pb-2 py-2 elevation-0 xs12">
            <h3 class="subtitle xs12 flex">
              <v-icon class="mt-0 mr-2">mdi-volume-high</v-icon>
              <span class="mt-0 pt-0 pb-3">Audio</span>
              <span><v-btn class="right mt-0 pt-0" icon @click="showUpload=!showUpload"><v-icon>add</v-icon></v-btn></span>
            </h3>
          </v-flex>
        </div>       -->

        <!-- <v-flex class="mr-5 pr-2 mt-0 mb-0 xs12" v-show="!showUpload">
          <v-btn icon class="mr-5 pr-2 right" @click="showUpload=!showUpload"><v-icon class="mr-2">add</v-icon> Add new audio</v-btn>
        </v-flex> -->
        <v-flex class="mt-0 mb-0 xs12" v-show="showUpload">
          <v-btn icon @click="showUpload=!showUpload"><v-icon>close</v-icon></v-btn>
          Cancel
        </v-flex>
        <v-flex v-if="showUpload">
          <v-container grid-list-xs fluid  class="elevation-3">
            <v-layout row wrap>
              <h4 class="headline">Add new audio</h4>

              <v-flex class="xs12">
                <v-text-field v-model="audio.title" label="Title"></v-text-field>
              </v-flex>

              <v-flex class="xs12 md6 pr-3">
                <v-select v-model="audio.channels" :items="constants.CHANNELS" item-value="id" item-text="name" label="Channels" class="ml-0"></v-select>
              </v-flex>

              <v-flex class="xs12 md6">
                <v-select v-model="audio.audio_resolution" :items="constants.AUDIO_RESOLUTIONS" item-value="id" item-text="name" label="Audio Resolution" class="ml-0"></v-select>
                <!-- <v-radio-group v-model="film.audio_resolution" label="Audio Resolution" row> -->
                  <!-- <v-radio v-for="s in ['32 kHz','44,1 kHz','48 kHz','96 kHz','192 kHz']" :label="s" :value="s" :key="s" class="ml-3"></v-radio> -->
                <!-- </v-radio-group> -->
              </v-flex>
              <v-flex class="xs12 md6 pr-3">
                <v-radio-group v-model="audio.audio_bit" label="Audio Bit" column>
                  <v-radio v-for="s in constants.AUDIO_BITS" :label="s.name" :value="s.id" :key="s.id" class="ml-3"></v-radio>
                </v-radio-group>
              </v-flex>

              <v-flex class="xs12 md6">
                <v-text-field v-model="audio.audio_container" label="Audio Container | Codec" hint='MP3, AAC, AC3 etc.'></v-text-field>
              </v-flex>
              <v-flex class="xs12 md6 pr-3">
                <v-text-field v-model="audio.bitrate_mbps" label="Bitrate in Mbps" suffix="Mbps"></v-text-field>
              </v-flex>
              <v-flex class="xs12 md6">
                <v-text-field v-model="audio.filesize" label="File Size" suffix="MB"></v-text-field>
              </v-flex>
              <!-- <v-flex class="xs12 md6">
                <v-text-field v-model="audio.title" label="Title"></v-text-field>
              </v-flex> -->
              <v-flex class="xs12">
                <v-textarea v-model="audio.other_specifications" label="Other Specifications" auto-grow rows=1></v-textarea>
              </v-flex>
              <v-flex class="xs12">
                <v-textarea v-model="audio.associated_information" label="Associated Information carriers (format migration story)" auto-grow rows=1></v-textarea>
              </v-flex>
              <v-flex class="xs12">
                <v-textarea v-model="audio.notes" label="Notes" auto-grow rows=1></v-textarea>
              </v-flex>
              <v-flex xs12>
                <h4 class='body-2'>Creation Date</h4>
                <v-date-picker landscape label="Creation Date" v-model="audio.creation_date"></v-date-picker>
              </v-flex>

              <v-flex xs12 sm12 md12 v-if="audios && audios.length>0">
                <v-list class="xs12">
                  <v-list-tile v-for="f in audios" :key="f.id">
                    <v-list-tile-title>
                      <b>{{f.title}}</b>
                    </v-list-tile-title>
                    <v-list-tile-title>audio_container: {{f.audio_container}}</v-list-tile-title>
                    <v-list-tile-title>bitrate: {{f.bitrate}}</v-list-tile-title>
                    <v-list-tile-action v-if="c_user.edit">
                      <v-btn @click="done_audio" icon ><v-icon small>edit</v-icon></v-btn>
                    </v-list-tile-action>
                    <v-list-tile-action v-if="c_user.delete_rights">
                      <v-btn @click="delete_audio" icon ><v-icon small>delete</v-icon></v-btn>
                    </v-list-tile-action>
                  </v-list-tile>
                  <v-divider></v-divider>
                </v-list>
              </v-flex>

              <!-- <edit-field-a v-for="field in fields" v-show="show_field_c(field)" :id="field.name" :name="field.name"
                :class="'flex ' + (field.class ? field.class : 'xs12')" :artwork="artwork"
                :field="field"
                :key="field.key"
                :audio="audio"
                v-model="field.name"
              >
              </edit-field-a> -->
            </v-layout>
          </v-container>
          <v-btn @click="add" v-if="c_user.edit">save</v-btn>
          <v-btn @click="showUpload=!showUpload">cancel</v-btn>
        </v-flex>
      <!-- </v-card> -->
    </v-layout>
  </div>
</template>

<script>
import EditField from './EditField'
// import languages from '@/data/languages'
import HeaderElements from './HeaderElements'
import ElementsTable from './ElementsTable'
const show_field = (field) => {
  if (field.condition && audio) {
    // var theInstructions = field.condition
    var F = (theInstructions) => {}
    return (F())
  } else {
    return true
  }
}
// const channels = [
//   {id: 1, value: '1', name: 'Single-channel'},
//   {id: 2, value: '2', name: 'Two-channel'},
//   {id: 3, value: '3', name: 'Three-channel'},
//   {id: 4, value: '4', name: 'Four-channel'},
//   {id: 5, value: '5', name: 'Five-channel'},
//   {id: 6, value: '6', name: 'Six-channel'},
//   {id: 7, value: '7', name: 'Seven-channel'},
//   {id: 8, value: '8', name: 'Eight-channel'},
//   {id: 9, value: '9', name: 'Nine-channel'},
//   {id: 10, value: '10', name: 'Ten-channel'},
//   {id: 11, value: '11', name: '11-channel'},
//   {id: 12, value: '12', name: '12-channel'},
//   {id: 13, value: '13', name: '13-channel'},
//   {id: 14, value: '14', name: '14-channel'},
//   {id: 15, value: '15', name: '15-channel'}
// ]
  export default {

    props: ['artwork'],
    data: () => ({
      audios: [],
      audio: {
        channels: 0,
        title: '',
        audio_resolution: '',
        bitrate: '',
        audio_container: '',
        bitrate_mbps: '',
        filesize: '',
        other_specifications: '',
        associated_information: '',
        creation_date: '',
        notes: ''
      },
      showUpload: false,
      show: false,
      fields: [
        {
          'ctype': 'text-short',
          'name': 'audio.title',
          'title': 'Title',
          column: true,
          class: 'xs12',
          edit: true,
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager']
        },
        {
          'ctype': 'radio',
          'etype': 'select',
          'selection': [
            {id: '1', value: '1', name: 'Single-channel'},
            {id: '2', value: '2', name: 'Two-channel'},
            {id: '3', value: '3', name: 'Three-channel'},
            {id: '4', value: '4', name: 'Four-channel'},
            {id: '5', value: '5', name: 'Five-channel'},
            {id: '6', value: '6', name: 'Six-channel'},
            {id: '7', value: '7', name: 'Seven-channel'},
            {id: '8', value: '8', name: 'Eight-channel'},
            {id: '9', value: '9', name: 'Nine-channel'},
            {id: '10', value: '10', name: 'Ten-channel'},
            {id: '11', value: '11', name: '11-channel'},
            {id: '12', value: '12', name: '12-channel'},
            {id: '13', value: '13', name: '13-channel'},
            {id: '14', value: '14', name: '14-channel'},
            {id: '15', value: '15', name: '15-channel'}
          ],
          'name': 'audio.channels',
          'title': 'channels',
          class: 'xs6',
          work_types: ['fvs'],
          user_groups: ['admin', 'manager']
        },
        {
          'ctype': 'radio',
          'etype': 'select',
          'selection': ['32 kHz', '44,1 kHz', '48 kHz', '96 kHz', '192 kHz'],
          'name': 'audio.audio_resolution',
          'title': 'Audio Resolution',
          class: 'xs6',
          work_types: ['fvs'],
          user_groups: ['admin', 'manager']
        },
        {
          'ctype': 'radio',
          'etype': 'select',
          'selection': ['16 Bit', '20 Bit', '24 Bit'],
          'name': 'audio.bitrate',
          'title': 'Bitrate',
          class: 'xs6',
          work_types: ['fvs'],
          user_groups: ['admin', 'manager']
        },
        {
          'ctype': 'text-short',
          'name': 'audio.audio_container',
          'title': 'Audio Container | Codec',
          column: true,
          class: 'xs6',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager']
        },
        {
          'ctype': 'text-short',
          'name': 'audio.bitrate_mbps',
          'title': 'Bitrate in Mbps',
          column: true,
          suffix: 'Mbps',
          class: 'xs6',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager']
        },
        {
          'ctype': 'text-short',
          'name': 'audio.filesize',
          'title': 'File Size',
          column: true,
          suffix: 'MB',
          class: 'xs6',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager']
        },
        {
          'ctype': 'text-short',
          'name': 'audio.title',
          'title': 'Title',
          column: true,
          class: 'xs6',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager']
        },
        {
          'ctype': 'text-long',
          'name': 'audio.other_specifications',
          'title': 'Other Specifications',
          column: true,
          class: 'xs12',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager']
        },
        {
          'ctype': 'text-long',
          'name': 'audio.associated_information',
          'title': 'Associated Information carriers (format migration story)',
          column: true,
          class: 'xs12',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager']
        },
        {
          'ctype': 'date',
          'name': 'audio.creation_date',
          'title': 'Creation Date)',
          column: true,
          class: 'xs6',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager']
        },
        {
          'ctype': 'text-long',
          'name': 'audio.notes',
          'title': 'Notes)',
          column: true,
          class: 'xs12',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager']
        }
      ]
    }),
    methods: {
      set_input (f) {
        audio[f] = f
      },
      download () {},
      add () {
        this.audios.push(this.audio)
        this.showUpload = !this.showUpload
      },
      delete_audio () {},
      done_audio () {},
      show_field_c (field) {
        // console.log(this.audio)
        return show_field(field, this.audio)
      }
    },
    computed: {
      c_user () {
        return this.$store.state.user.profile
      }
    },
    components: {
      'edit-field-a': EditField, HeaderElements, ElementsTable
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/artworks/Audio.vue